import { Store } from '@ngrx/store';
import { showErrorNotificationDialogAction } from 'app/store/global/dialog/dialog.action';
import { uploadFilenameValidators } from '../helpers/helper-functions';

export const fileConfig = {
  download: (fileLink: string): void => {
    const newTab = window.open('', '_blank');
    const aLink = document.createElement('a');
    aLink.href = fileLink;
    aLink.download = fileLink;

    if (newTab) {
      newTab.document.body.appendChild(aLink);
      aLink.click();
      setTimeout(() => {
        newTab.close();
      }, 1000);
    } else {
      window.location.href = fileLink;
    }
  },
  upload: (file: File, name: string, store: Store): FormData | null => {
    if (file) {
      const validateFileName = uploadFilenameValidators(file?.name);
      if (validateFileName) {
        store.dispatch(
          showErrorNotificationDialogAction({
            error: {
              message: validateFileName,
              succes: false,
            },
          })
        );
        return null;
      }

      const formData: FormData = new FormData();
      formData.append(name, file);

      return formData;
    } else {
      store.dispatch(
        showErrorNotificationDialogAction({
          error: {
            message: 'No file/s selected',
            succes: false,
          },
        })
      );
      return null;
    }
  },
};
